import { z } from 'zod';

/** Placeholder lobby emotes. Finished dance choreography, audio and character animation are deferred design work. */
export const EMOTE_IDS = ['wave', 'bounce', 'spin', 'cheer'] as const;
export const EmoteId = z.enum(EMOTE_IDS);
export type EmoteId = z.infer<typeof EmoteId>;

/**
 * Ephemeral, validated, rate-limited lobby event. Broadcast once with a server timestamp,
 * never persisted, never replayed to reconnecting clients, and never affects readiness or start.
 */
export const LobbyEmoteEvent = z.object({
  actorId: z.string(),
  emoteId: EmoteId,
  at: z.number(),
});
export type LobbyEmoteEvent = z.infer<typeof LobbyEmoteEvent>;
